<i class="fas fa-star" *ngFor="let star of fullStars"></i>
<i class="fas fa-star-half-alt" *ngIf="hasHalfStar"></i>
<i class="far fa-star" *ngFor="let star of emptyStars"></i>
